module.exports = __webpack_public_path__ + "6766370bd5bb2b441d0aa4de2e25f30d.png";